<template>
  <div>
    <router-view />
    <now-loading :value="isLoading" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NotifyToast from '@/components/mixin/NotifyToast.js'
import NowLoading from '@/components/parts/NowLoading.vue'

export default {
  components: {
    NowLoading,
  },
  mixins: [NotifyToast],
  computed: {
    ...mapState(['isLoading']),
    ...mapGetters({ existToken: 'auth/existToken' }),
  },
}
</script>

<style lang="scss" scoped></style>
